/** sorts a location array by placing the current location on first position */
export function sortLocationsByCurrentLocation(currentLocationId, locations = [{}]) {
    if (!currentLocationId) {
        return locations;
    } else {
        const currentLocation = locations.find(l => l.id === currentLocationId);
        if (!currentLocation) {
            return locations;
        } else {
            return [
                currentLocation,
                ...locations.filter(l => l.id !== currentLocationId),
            ];
        }
    }
}
